import Vue from 'vue'
import { FormGroup } from 'bootstrap-vue/es/components'
import Vuemerang from 'vuemerang'
import 'vuemerang/dist/vuemerang.css'

Vue.use(FormGroup)
Vue.use(Vuemerang, {
  theme: {
    colors: {
      primary: '#114634',
      success: 'rgb(23, 201, 100)',
      danger: 'rgb(242, 19, 93)',
      warning: 'rgb(255, 130, 0)',
      dark: 'rgb(36, 33, 69)',
      gray: '#afbbc6'
    }
  }
})
